var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVimeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    width: 32,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M31.862 7.204c.239-1.359.233-2.759-.593-3.815-1.155-1.482-3.612-1.537-5.296-1.275-1.371.212-6.002 2.287-7.578 7.252 2.792-.216 4.257.204 3.988 3.324-.114 1.307-.764 2.737-1.488 4.108-.838 1.58-2.409 4.685-4.469 2.447-1.855-2.014-1.716-5.865-2.141-8.43-.236-1.439-.485-3.232-.95-4.712-.4-1.273-1.318-2.808-2.44-3.14-1.206-.36-2.697.202-3.573.725C4.535 5.352 2.412 7.717 0 9.668v.183c.479.463.605 1.224 1.311 1.327 1.659.248 3.241-1.569 4.346.321.67 1.156.879 2.424 1.31 3.669.574 1.659 1.019 3.467 1.489 5.375.793 3.231 1.771 8.062 4.523 9.244 1.405.604 3.516-.205 4.584-.848 2.896-1.739 5.151-4.26 7.082-6.824 4.415-6.069 6.851-12.945 7.217-14.911z",
    fill: "#00ADEF",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.20019abf.svg";
export { ForwardRef as ReactComponent };